import { createAsyncThunk } from "@reduxjs/toolkit";
import { authApi } from "../../http";

export const getMeAction = createAsyncThunk(
    'auth/me',
    (): Promise<any> => {
        return authApi.getMe();
    }
)